import {
    /** FETCH APPLICATION  */
    FETCH_DETTACHFILE_FULFILLED,
    FETCH_DETTACHFILE_REJECTED,
    FETCH_DETTACHFILE_PENDING,
    RESET_DETTACHFILE
} from "../../actions/v3/dettachFile";
const initialState = {
    done: false,
    error: false,
    spinner: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_DETTACHFILE_PENDING:
            return {
                done: false,
                error: false,
                spinner: true
            };
        case FETCH_DETTACHFILE_FULFILLED:
            return {
                ...state,
                dettachFile: action.payload,
                done: true,
                spinner: false
            };
        case FETCH_DETTACHFILE_REJECTED:
            return {
                ...state,
                error: action.payload,
                done: false,
                spinner: false
            };
        case RESET_DETTACHFILE:
            return {
                initialState,
                done: false,
                error: false,
            };
        default:
            return state;
    }
};